"use client";

import DeletePopover from "@/app/shared/delete-popover";
import PencilIcon from "@/components/icons/pencil";
import { HeaderCell } from "@/components/ui/table";
import { IProjectCategory } from "@/utilities/types/ProjectCategory";
import { ActionIcon, Tooltip } from "rizzui";

type Columns = {
  data: IProjectCategory[];
  onDeleteItem: (id: string) => Promise<void>;
  onEditItem: (row: IProjectCategory) => void;
};

export const getColumns = ({ onDeleteItem, onEditItem }: Columns) => [
  {
    title: (
      <HeaderCell
        title="Name"
        align="center"
      />
    ),
    key: "name",
    dataIndex: "name",
    align: "center",
    render: (value: string | Record<string, string>) => {
      return typeof value === "string" ? value : value?.en;
    },
  },
  {
    title: (
      <HeaderCell
        title="Short Name"
        align="center"
      />
    ),
    key: "shortname",
    dataIndex: "shortname",
    align: "center",
    render: (value: string | Record<string, string>) => {
      return typeof value === "string" ? value : value?.en;
    },
  },
  {
    title: (
      <HeaderCell
        title="Type"
        align="center"
      />
    ),
    dataIndex: "type",
    key: "type",
    align: "center",
  },
  {
    title: (
      <HeaderCell
        title="Slug"
        align="center"
      />
    ),
    dataIndex: "slug",
    key: "slug",
    align: "center",
  },

  {
    title: (
      <HeaderCell
        className="ps-3"
        title={<span className="whitespace-nowrap">Actions</span>}
        align="center"
      />
    ),
    dataIndex: "action",
    key: "action",
    width: 120,
    render: (_: string, row: IProjectCategory) => (
      <div className="flex items-center justify-end gap-3 pe-4">
        <Tooltip
          size="sm"
          content={"Edit Project Category"}
          placement="top"
          color="invert"
        >
          <ActionIcon
            size="sm"
            variant="outline"
            onClick={() => onEditItem(row)}
          >
            <PencilIcon className="h-4 w-4" />
          </ActionIcon>
        </Tooltip>
        <DeletePopover
          title={`Delete project category`}
          description={`Are you sure you want to delete this project category?`}
          onDelete={async () => await onDeleteItem(row.id)}
        />
      </div>
    ),
  },
];
